function bm_callbacks_get_platform(){
    return docCookies.getItem('platform') || '';
}

function bm_callbacks_get_regulation(){
    return docCookies.getItem('sub_regulation') || 'cysec';
}